import { StyleSheet } from 'aphrodite';
import { prestoPurple } from '../../../../web/styles/colors';
import { CssSelectors, Layouts } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	actionBar: {
		height: 62,
		marginBottom: 30,
		...Layouts.horizontalStack(20),
	},
	actionBarButton: {
		opacity: 1,
		transform: 'translate3d(0,0,0)',
		alignItems: 'center',
		background: 'none',
		borderRadius: 20,
		boxShadow: 'none',
		display: 'flex',
		marginRight: 12,
		padding: '8px 10px',
		transition: 'background 0.2s, box-shadow 0.2s, transform 0.1s',
		':hover': {
			boxShadow: `0 1px 2px 1px  ${prestoPurple}`,
		},
		':active': {
			...CssSelectors.allChildren(
				{
					boxShadow: `0 0 2px 1px rgba(0,0,0, 0.1) !important`,
					transform: 'translate3d(0,0,0) !important',
				},
				'span'
			),
		},
	},
});
